export const SSO_TOKEN_KEY = 'ssoAccessToken';

export const getTokenFromLocalStorage = () => {
  const data = localStorage.getItem(SSO_TOKEN_KEY);
  if (!data) {
    // if no value exists associated with the key, return null
    return null;
  }

  const item = JSON.parse(data);

  // If TTL has expired, remove the item from localStorage and return null
  if (Date.now() > item.ttl) {
    localStorage.removeItem(SSO_TOKEN_KEY);

    return null;
  }

  // return data if not expired
  return item.value;
};

export const setTokenInLocalStorage = (token: string) => {
  // create token value for local storage with expiry time
  const data = {
    value: token,
    ttl: Date.now() + 86400 * 1000,
  };

  // set value in local storage
  localStorage.setItem(SSO_TOKEN_KEY, JSON.stringify(data));
};
